import * as React from 'react';
import * as moment from 'moment';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import GuardsAllowedAccess from '../../components/Stats/guards-allowed-access';
import * as StatsApi from '../../api/stats';

class VisitorsContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      buildings: [],
      form: {
        building_id: null,
        from: moment().startOf('month'),
        to: moment().endOf('day'),
        type: '__none__',
      },
      data: null,
      empty: false,
    };

    this.onSubmit = this.onSubmit.bind(this);
  }

  async onSubmit(body) {
    this.setState({
      form: body
    });

    const { building_id, ...rest } = body;
    const res = await StatsApi.guardsAllowedAccess(building_id, rest);

    this.setState({ data: res.data });
  }

  static getDerivedStateFromProps(props, state) {
    if (props.buildings && props.buildings.length && !state.form.building_id) {
      return {
        form: {
          ...state.form,
          building_id: props.buildings[0].id,
        },
      };
    }

    return null;
  }

  async componentDidMount() {
    const { i18n } = this.props;
    const language = i18n.language.substr(0, 2);
    moment.locale(language);
  }

  render() {
    if (this.state.isLoading) {
      return null;
    }

    return (
      <GuardsAllowedAccess
        buildings={this.props.buildings}
        onSubmit={this.onSubmit}
        form={this.state.form}
        data={this.state.data}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  buildings: state.buildings.records.filter((b) => b.permissions.reports),
});

export default withTranslation()(connect(mapStateToProps)(VisitorsContainer));
